var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLayout',{scopedSlots:_vm._u([{key:"sub-nav",fn:function(){return [_c('SubNav',[_c('project-sub-nav',{attrs:{"tenant":_vm.tenant.current,"project":_vm.project.current}})],1)]},proxy:true}])},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }